module.exports = {
  async getFloorThings(floorId) {
    const url = `${this.url}/${this.version}/floors/${floorId}/things`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
  async getFloorThingExTags(floorId) {
    const url = `${this.url}/${this.version}/floors/${floorId}/things`;
    const params = { inclusionTypes: ['Thing::WhereExTag'] }
    const response = await this.get(url, params, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/floor_things_api.js